import React, { useMemo, useState } from 'react';
import ReactMarkdown from 'react-markdown';

const normaliseOptionList = (value) => {
  if (Array.isArray(value)) return value.map((item) => String(item).trim()).filter(Boolean);
  return String(value || '')
    .split(/\r?\n|,/)
    .map((item) => item.trim())
    .filter(Boolean);
};

const getProfileInitial = (value = '') => {
  const trimmedValue = value.trim();
  return trimmedValue ? trimmedValue.charAt(0).toUpperCase() : 'P';
};

function ProfileCardAsset({ asset, assetLinkUrl }) {
  const [isShowingDetails, setIsShowingDetails] = useState(false);
  const qualifications = useMemo(() => normaliseOptionList(asset.qualifications), [asset.qualifications]);
  const tags = useMemo(() => normaliseOptionList(asset.tags), [asset.tags]);
  const primaryQualification = qualifications[0] || asset.section || 'Profile';
  const hasDetails = Boolean(asset.experience || qualifications.length || asset.externalUrl);

  return (
    <div className={`asset-profile-card ${asset.isPrimaryAction ? 'is-featured' : ''}`}>
      <div className="asset-profile-card-main">
        <div className="asset-profile-card-topline">
          <div className="asset-profile-card-header">
            <span className="asset-profile-card-avatar">
              {asset.iconUrl ? <img src={asset.iconUrl} alt="" /> : getProfileInitial(asset.title || asset.ctaLabel)}
            </span>
            <div className="min-w-0">
              {asset.section && <p className="asset-profile-card-section">{asset.section}</p>}
              <h3>{asset.title || 'Untitled profile'}</h3>
              {asset.tagline && <p className="asset-profile-card-tagline">{asset.tagline}</p>}
            </div>
          </div>
          {asset.isPrimaryAction && <span className="asset-profile-card-badge">Featured</span>}
        </div>

        <div className="asset-profile-card-feature">
          <p>Primary credential</p>
          <span>{primaryQualification}</span>
        </div>

        {asset.description && (
          <div className="asset-profile-card-summary">
            <ReactMarkdown>{asset.description}</ReactMarkdown>
          </div>
        )}

        {tags.length > 0 && (
          <div className="asset-profile-card-tags">
            {tags.slice(0, 5).map((tag) => <span key={tag}>{tag}</span>)}
          </div>
        )}

        {isShowingDetails && (
          <div className="asset-profile-card-details">
            {asset.experience && (
              <div className="asset-profile-card-detail-block">
                <p className="label-caps">Experience</p>
                <p>{asset.experience}</p>
              </div>
            )}
            {qualifications.length > 0 && (
              <div className="asset-profile-card-detail-block">
                <p className="label-caps">Qualifications</p>
                <ul>
                  {qualifications.map((qualification) => <li key={qualification}>{qualification}</li>)}
                </ul>
              </div>
            )}
            <div className="asset-profile-card-detail-block">
              <p className="label-caps">Main profile</p>
              <p>{asset.externalUrl || 'Add a main profile URL.'}</p>
            </div>
          </div>
        )}
      </div>

      <div className="asset-profile-card-actions">
        <a
          className={`asset-profile-card-primary ${assetLinkUrl ? '' : 'is-disabled'}`}
          href={assetLinkUrl || undefined}
          rel="noreferrer"
          target="_blank"
        >
          {asset.ctaLabel || 'Open profile'}
        </a>
        <button
          className="asset-profile-card-secondary"
          disabled={!hasDetails}
          onClick={() => setIsShowingDetails((current) => !current)}
          type="button"
        >
          {isShowingDetails ? 'Hide details' : 'Details'}
        </button>
      </div>
    </div>
  );
}

export default ProfileCardAsset;
